module.exports = __webpack_public_path__ + "static/img/buy_zhuangbei.59f16828.png";